module.exports = __webpack_public_path__ + "static/media/pdo01.814ba4ea.jpg";